import { z } from 'zod'

export let trainingSeriesSchema = z.object({
  name: z.string().min(1, 'Training series name is required'),
  courseIDs: z.array(z.string()).min(1, 'At least one course must be selected'),
})

export type TrainingSeriesFormData = z.infer<typeof trainingSeriesSchema>
